// @flow
import {NAVIGATION_UPDATE_ORDER} from "../actions";

export type NavigationUpdateState = {
	isSubmitting: boolean,
	isVinBlocked: boolean,
};

const initialState: NavigationUpdateState = {
	isSubmitting: false,
	isVinBlocked: false,
};

const navigationUpdateReducer = (state: NavigationUpdateState = initialState, action: any): NavigationUpdateState => {
	switch (action.type) {
		case NAVIGATION_UPDATE_ORDER.REQUEST:
			return {
				...state,
				isSubmitting: true,
				isVinBlocked: false,
			};
		case NAVIGATION_UPDATE_ORDER.SUCCESS:
			return {
				...state,
				isSubmitting: false,
			};
		case NAVIGATION_UPDATE_ORDER.FAILURE:
			return {
				...state,
				isSubmitting: false,
			};
		case NAVIGATION_UPDATE_ORDER.VIN_BLOCKED:
			return {
				...state,
				isSubmitting: false,
				isVinBlocked: true,
			};
		case NAVIGATION_UPDATE_ORDER.MAIL_FAILURE:
			return {
				...state,
			};
		default:
			return state;
	}
};

export default navigationUpdateReducer;
